import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ServiceordreFilter } from '../../aftale/models';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PartnerBaseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-base-dto';
import { PartnerService } from 'src/app/api/services/partner.service';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
    selector: 'app-unparented-filter',
    templateUrl: './unparented-filter.component.html',
    styleUrls: ['./unparented-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnparentedFilterComponent implements OnInit, OnDestroy {
  caller: string = 'OK.Egis.Portal';
  partners: PartnerBaseDto[];

  isLoading: boolean = false;

  @Input() filter: ServiceordreFilter;

  unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private partnerService: PartnerService,
    private errorHandler: ErrorHandlerService,
    private loader: LoaderService,
    private localStorage: LocalStorageService
  ) {}

  ngOnInit(): void {
    let loaderRef = this.loader.createLoader();
    loaderRef.showStateChanged$.subscribe((shouldShow) => {
      this.isLoading = shouldShow;
    });

    this.changeFilterParams();
    loaderRef.start();
    this.partnerService
      .getAllPartnere({
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          loaderRef.stop();
        })
      )
      .subscribe(
        (response) => {
          this.partners = response;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  hasFilters(): boolean {
    return this.filter.partnerNos.length > 0;
  }

  filterCount() {
    return this.filter.partnerNos.length;
  }

  toggleValue(array: any[], id: number) {
    if (array.indexOf(id) > -1) {
      array.splice(array.indexOf(id), 1);
    } else {
      array.push(id);
    }
    this.changeFilterParams();
  }

  changeFilterParams() {
    const uniquePartnerNos = this.filter.partnerNos.filter((v, i, a) => a.indexOf(v) === i);

    this.localStorage.set('unparented-filter', this.filter);

    const queryParams: Params = {
      partnerNos: this.filter.partnerNos.length > 0 ? uniquePartnerNos : null,
    };

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
  }

  reset() {
    this.filter = {
      partnerNos: [],
    };
    this.changeFilterParams();
  }

  onPartnerChange(partnerNos: number[]) {
    this.filter.partnerNos = partnerNos;
    this.changeFilterParams();
  }
}
